export enum LeoButtonPopoverType {
  HISTORY = 'history',
  INITIAL_FLOW_CREATION = 'initialFlowCreation',
  MEET = 'meet',
  MINIMIZED = 'minimized',
  NONE = 'none',
  UNSAVED_FLOW = 'unsavedFlow',
}
